import ActionCable from 'actioncable'

class Websocket {
  constructor() {
    this.cable = ActionCable.createConsumer();
  }

  bindEvents() {}
}


export default Websocket;




// WEBPACK FOOTER //
// ./app/javascript/packs/websocket.js